class SaDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('.drawer-menu');

    this.connectedMenu = document.querySelector('.sa-top-menu');
	  const self = this;
	  
    const maxViewport = 1140;
    const elements = document.querySelectorAll('.nav-icon, .nav-icon--top, [data-open-main-menu], [href*="#menu-"], [menu--trigger], [menu-triger]');
    //console.log('elements', elements);
    elements.forEach(function(element) {
      	element.addEventListener('click', function (e) {
			e.preventDefault();
			document.querySelector('.drawer-menu-header span').innerHTML = 'Menu';
			let target = element.getAttribute('data-target');
			if (!target && element.getAttribute('href') && element.getAttribute('href').includes('#menu-')) {
				// Code to be executed if href contains '#menu-'
				const href = element.getAttribute('href');
				if (href.includes('#menu-')) {
					const value = href.substring(href.indexOf('#menu-') + 6);
					// value will contain the string after '#menu-'
					// console.log(value);
					target = value;
				}
			}
	
			
              
			if (target) {
				//self.open(element.getAttribute('data-target'));
				self.drawer.querySelectorAll('[data-menu]').forEach(item => {
				let tt; let tt2;
				try{
					tt =  item.querySelector('a > .menu-flex .menu-title').textContent
					tt2 = element.textContent 
				}
				catch(eror){

				}
					
          			//if (item.getAttribute('data-menu') == target  ||  tt.trim() == tt2.trim() ) {
					if (item.getAttribute('data-menu') == target) {
						let Elmtarget = item;  
						
						item.closest('ul').querySelectorAll('.menu-holder').forEach(item => {
							item.classList.remove('active')
						})
					
						let currentTitle;

						let firstHref = item.querySelector('a');

						//console.log(firstHref)

            			//console.log('target', [target, item.getAttribute('data-menu')])

						if (Elmtarget.classList.contains('menu-title')) {
							currentTitle = Elmtarget.textContent
						}
						else if(Elmtarget.querySelector('.menu-title')){
							currentTitle = Elmtarget.querySelector('.menu-title').textContent
						}
						else {
							currentTitle = Elmtarget.closest('li').querySelector('.menu-title').textContent
						}

        				

						if (firstHref.nextElementSibling) {
							firstHref.nextElementSibling.classList.add('active');
							
							if(window.innerWidth > maxViewport) {
								firstHref.nextElementSibling.classList.add('asPrimary');
								document.querySelector('#drawer-menu').classList.add('notPrimary')

								if (firstHref.nextElementSibling) {
									var parentMenuHolder = firstHref.parentElement;
									var n = 0;
									
									while (parentMenuHolder && !parentMenuHolder.classList.contains('menu-holder')) {
										parentMenuHolder = parentMenuHolder.parentElement;
										console.log('parentMenuHolder', parentMenuHolder) 
										n++;
									}

									if (parentMenuHolder) {
										//console.log('parentMenuHolder', parentMenuHolder)
										parentMenuHolder.classList.add('active');
										if (parentMenuHolder.querySelector('.menu-holder') === null) {
											parentMenuHolder.classList.remove('asPrimary');
										} else {
											parentMenuHolder.classList.add('asPrimary');
											var prevSibling = parentMenuHolder.previousElementSibling;
											if (prevSibling && prevSibling.classList.contains('drawer-menu-header')) {
												parentMenuHolder.classList.remove('asPrimary');
											} else {
												parentMenuHolder.classList.add('asPrimary');

												const holders = self.listMenuHolders(firstHref, ['asPrimary', 'active']);
												console.log('holders', holders) 
											}
										}
									}
								}
							}
							else {
								console.log('no target', target) 
								document.querySelector('#drawer-menu').classList.remove('notPrimary');
								var parentMenuHolder = firstHref.parentElement;
								while (parentMenuHolder && !parentMenuHolder.classList.contains('menu-holder')) {
									parentMenuHolder = parentMenuHolder.parentElement;
								}

								if (parentMenuHolder) {
									//parentMenuHolder.classList.add('active');
									var prevSibling = parentMenuHolder.previousElementSibling;
									if (prevSibling && prevSibling.classList.contains('drawer-menu-header')) {
										parentMenuHolder.classList.remove('active');
									} else {
										parentMenuHolder.classList.add('active');
										const holders = self.listMenuHolders(firstHref, ['active']);
										console.log('holders', holders) 
									}
								}
							}
						}

						let offWidth = 0
						document.querySelectorAll('.menu-holder.active').forEach(t => {
							t.style.transform = "";
							if(window.innerWidth < maxViewport) {
								offWidth += window.innerWidth
							}
							else {
								offWidth += t.offsetWidth
							}
							
							console.log('elem', t)
						})

						document.querySelectorAll('.menu-holder.forceActive').forEach(t => {
							if(window.innerWidth < maxViewport) {
								offWidth += window.innerWidth
							}
							else {
								offWidth += t.offsetWidth
							}
						})

						if(window.innerWidth < maxViewport) {
							offWidth = window.innerWidth;
						}
	
						document.querySelector('.drawer-menu-header span').innerHTML = '';
						document.querySelector('.drawer-menu-header').classList.remove('over')
						if (offWidth > window.innerWidth || window.innerWidth < maxViewport) {
							// console.log('over width', offWidth);
							document.querySelector('.drawer-menu-header').classList.add('over')
	
							const elements = document.querySelectorAll('.menu-holder.active:not(.asPrimary)');
							const lastElement = elements[elements.length - 1];
	
	
							let columnWidth = 350; // default column width
							if (window.innerWidth < maxViewport) { // check if mobile device
								columnWidth = window.innerWidth; // set column width to 100% of screen width
							}
	
							let dimention = (offWidth - window.innerWidth)
							if (window.innerWidth < maxViewport) {
								document.querySelector('.drawer-menu-header span').innerHTML = currentTitle;
								const devided = Math.ceil(offWidth / window.innerWidth);
								elements.forEach((t, index) => {
									if (index == 0) {
										const leftPercentage = -devided * 100;
										t.style.transform = `translateX(${leftPercentage}%)`;
										t.style.height = 'auto';
										t.style.top = '0';
										t.style.overflow = 'visible';
										t.setAttribute('data-left', leftPercentage)
										t.classList.add('pushLeft')
									}
								})
							} else {
								document.querySelector('.drawer-menu-header span').innerHTML = 'Back';
								const columnHidden = Math.ceil((dimention) / columnWidth)
								elements.forEach((t, index) => {
									if (index == 0) {
										t.style.transform = `translateX(-${columnHidden * t.offsetWidth}px)`
										t.setAttribute('data-left', columnHidden * t.offsetWidth)
										t.classList.add('pushLeft')
									}
								})
							}
	
							//document.querySelector("#drawer-menu").classList.add('notPrimary')
						}

						self.drawer.querySelector('.main-menu').classList.add('active');

						self.drawer.classList.add('active')
						if (!document.querySelector('.sa-backdrop')) {
							const backdrop = document.createElement('div');
							backdrop.className = 'sa-backdrop';
							backdrop.onclick = function(e) {
								self.close();
							}
							document.querySelector('body').append(backdrop);
						}

						document.querySelector('body').classList.add('sa-overlay');
						
						setTimeout(() => {
							self.lazyloadImage();
							document.querySelectorAll('asPrimary').forEach(elm =>console.log(elm))
						}, 500);

					}
				});
			}
			else {
				self.open();
				setTimeout(() => {
				self.lazyloadImage()
				}, 500);
			}
		});
	});
    
	document.addEventListener('click', (e) => {
		if (e.target.closest('.sticky-header')) {
			const menuId = e.target.getAttribute('data-id');
			if(menuId && e.target.classList.contains('has-children')){
        		e.preventDefault();
				self.open(menuId);
			}
    	}
    
    	if (e.target.closest('.menu-mini-items2')) {
        let menuId = e.target.getAttribute('data-side');
        if (!menuId) menuId = e.target.closest('.menu-mini-item').getAttribute('data-side');
          console.log(menuId)
        if(menuId){
          e.preventDefault();
          self.open(menuId);
        }
      }
    
      if (e.target.closest('.breadcumbs---wrapper2')) {
        let menuId = e.target.getAttribute('data-side');
        if (!menuId) menuId = e.target.closest('a').getAttribute('data-side');
          console.log(menuId)
        if(menuId){
          e.preventDefault();
          self.open(menuId);
        }
      }
	})
    
    this.drawer.querySelectorAll('.drawer-menu-header span').forEach(btn => {
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        // console.log('back now', event.target.closest('.notPrimary'))
        if(event.target.closest('.notPrimary')){
          document.querySelectorAll('.notPrimary').forEach(n => n.classList.remove('notPrimary'))
          self.drawer.querySelectorAll('.asPrimary').forEach(n => {
            n.classList.remove('asPrimary')
            n.querySelectorAll('.active').forEach(t => t.classList.remove('active'));
            n.classList.remove('active')
          })
        }
      })
    })

    this.drawer.querySelectorAll('.close-btn').forEach(btn => {
      btn.addEventListener('click', function(event) {
        // console.log('close me')
        event.preventDefault();
        self.close();
      })
    })

    this.connectedMenu.querySelectorAll('li > a').forEach(btn => {
      btn.addEventListener('click', function(event) {
        const menuId = btn.getAttribute('data-id');
        // alert(menuId)
        // console.log(menuId)
        if(menuId && btn.classList.contains('has-children')){
          event.preventDefault();
          self.open(menuId);
        }
      })
    }) 
    
    this.drawer.querySelectorAll('[data-menu]').forEach(item => {
      item.addEventListener('click', function(e) {  
        
        const target = e.target.closest('li').getAttribute('data-menu');   
        if(self.drawer.querySelectorAll(`#subMenu-${target}`).length > 0){
              e.preventDefault();
            item.closest('ul').classList.add('move') 
            setTimeout(function(){
              item.closest('ul').classList.remove('active')
              // item.closest('ul').classList.remove('move')
            }, 100);
            if(item.closest('.main-menu')) item.closest('.main-menu').classList.remove('active')
            
			self.drawer.querySelectorAll(`#subMenu-${target}`).forEach(child => {
              // console.log()
              child.classList.add('active')
              self.drawer.querySelectorAll(`.toptext-${target}`).forEach(toptext => {
                toptext.classList.add('active')
              })
            }) 
		}
		  
		e.target.closest('ul').querySelectorAll('.menu-holder').forEach(item => {
			item.classList.remove('active')
		})

        try{
          var targetClasses = ['menu-title', 'menu-image'];
          if (targetClasses.some(className => e.target.classList.contains(className))) {
            //console.log('TRUE')
            e.target.closest('a')
              .nextElementSibling
              .classList.add('active');
          }
          else {
            //console.log('FALSE')
            if (e.target.tagName.toLowerCase() !== 'a') {
              e.target.closest('a')
              .nextElementSibling
              .classList.add('active');
            }
            else {
              e.target
              .nextElementSibling
              .classList.add('active');
            }
            
          }

          if(item.classList.contains('has-children')){
            //console.log('has children', e.target.classList)
            e.preventDefault();
          }
        }
        catch(err){
            console.warn(err)
        }
        
        
      })
    })
    
    this.drawer.querySelectorAll('.back-menu').forEach(item => {
      item.addEventListener('click', function(e) {
        const target = e.target.closest('li').getAttribute('data-parent');
        // console.log('click back', self.drawer.querySelectorAll(`[data-menu="${target}"]`).length )
        self.drawer.querySelectorAll(`.toptext-${target}`).forEach(toptext => {
            toptext.classList.remove('active')
        })
        
        if(target && self.drawer.querySelectorAll(`#subMenu-${target}`).length > 0){
            self.drawer.querySelector(`#subMenu-${target}`).classList.add('active')
            self.drawer.querySelector(`#subMenu-${target}`).classList.remove('move')
            item.closest('ul').classList.remove('active')
        }
        else if(target && self.drawer.querySelectorAll(`[data-menu="${target}"]`).length > 0){
           self.drawer.querySelectorAll(`[data-menu="${target}"]`).forEach(child => {
            child.classList.add('active')
             child.classList.remove('move')
            item.closest('ul').classList.remove('active')
          })
        }
        else {
          self.drawer.querySelector('.main-menu').classList.add('active')
          item.closest('ul').classList.remove('active')
          self.drawer.querySelectorAll(`.toptext`).forEach(toptext => {
            toptext.classList.remove('active')
          })
        }
       
      });
    });
  }
	
  isDrawerMenuHeader(element) {
		return element && element.classList.contains('drawer-menu-header');
	}
	
  addClassesToMenuHoldersParentOfElement(element, classesToAdd) {
		var parentMenuHolder = element.closest('.menu-holder');
		
		// Check if there is a previous .drawer-menu-header sibling
		while (parentMenuHolder) {
			var previousSibling = parentMenuHolder.previousElementSibling;
			var foundHeader = false;
			
			// Iterate through previous siblings to find a .drawer-menu-header
			while (previousSibling) {
				if (previousSibling.classList.contains('drawer-menu-header')) {
					foundHeader = true;
					break;
				}
				previousSibling = previousSibling.previousElementSibling;

				
			}
			console.log(foundHeader)
			// If a .drawer-menu-header sibling is found, add classes to the current .menu-holder
			if (foundHeader) {
				for (var i = 0; i < classesToAdd.length; i++) {
					parentMenuHolder.classList.add(classesToAdd[i]);
				}
			} else {
				break; // No more .drawer-menu-header siblings found
			}

			parentMenuHolder = parentMenuHolder.closest('.menu-holder');
		}
  }
	
  	listMenuHolders(childElement, classesToAdd) {
		const menuHolders = [];

		// Traverse the DOM tree upward and find all menu-holder elements
		let currentElement = childElement.parentElement;
		while (currentElement) {
			if (currentElement.classList.contains('menu-holder') && !this.isDrawerMenuHeader(currentElement.previousElementSibling)) {
				menuHolders.push(currentElement);

				// Add CSS to the menu-holder element
				//currentElement.classList.add('active')
				//currentElement.classList.add('asPrimary')

				for (var i = 0; i < classesToAdd.length; i++) {
					currentElement.classList.add(classesToAdd[i]);
				}
			}

			currentElement = currentElement.parentElement;
		}
			
		return menuHolders;
	}


	addClassToMenuHoldersAboveElement(element, classesToAdd) {
		var parentMenuHolder = element.closest('.menu-holder');
		// Create a limit to avoid infinite looping
		var limit = 10; // Adjust the limit as needed

		while (parentMenuHolder && limit > 0) {
			for (var i = 0; i < classesToAdd.length; i++) {
				parentMenuHolder.classList.add(classesToAdd[i]);
			}
	
			parentMenuHolder = parentMenuHolder.closest('.menu-holder');
			limit--;

			console.log('parentMenuHolder', parentMenuHolder)
		}
	}
	
  	addClassesToMenuHolders(element, classesToAdd) {
		var parentMenuHolder = element;
		for (var i = 0; i < classesToAdd.length; i++) {
			if (parentMenuHolder) {
				parentMenuHolder = parentMenuHolder.closest('.menu-holder');
				if (parentMenuHolder) {
					parentMenuHolder.classList.add(classesToAdd[i]);
				} else {
					break; // No more .menu-holder elements found
				}
			}
		}
	}

  getNextSibling(elem, selector) {

	// Get the next sibling element
	var sibling = elem.nextElementSibling;

	// If there's no selector, return the first sibling
	if (!selector) return sibling;

	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.nextElementSibling
	}

    return sibling;

};

  async loadImages(){
    await this.lazyload();
  }

  async imageUrlToBase64(url){
    const response = await fetch(url);
    const blob = await response.blob();
    return blob;
  }

  async lazyload(){
    /*
      if(this.drawer.querySelectorAll(`.lazyloaded`).length > 0){
      this.drawer.querySelectorAll(`.lazyloaded`).forEach(async child => {
          const url = child.getAttribute('data-image')
          const img = await this.imageUrlToBase64(url)
          console.log(img)
      });
    }
    */
  }

  open(menuId = false) {
    const drawer = this;
    //console.log('open', menuId)
    const menuDetect = () => {
      return new Promise((resolve, reject) => {
        document.querySelectorAll('.forceActive').forEach(tt => tt.classList.remove('forceActive'))
        this.drawer.querySelectorAll(`[data-menu="${menuId}"]`).forEach(t => {
            if(t.querySelector('.menu-holder')) t.querySelector('.menu-holder').classList.add('active')
            if(t.querySelector('.menu-list'))t.querySelector('.menu-list').classList.add('active')
            if(t.querySelector('.menu-holder')) t.querySelector('.menu-holder').classList.add('asPrimary')
            document.querySelector('.drawer-menu').classList.add('notPrimary');
            t.closest('.menu-holder').closest('.menu-holder').classList.add('forceActive')
        })
        
        if(menuId && this.drawer.querySelectorAll(`#subMenu-${menuId}`).length > 0){
            this.drawer.querySelectorAll('.sub-main-menu').forEach(menu => {
               menu.classList.remove('active')
               menu.classList.remove('move')
            });
            
            this.drawer.querySelectorAll(`#subMenu-${menuId}`).forEach(child => {
              child.classList.add('active')
              if(this.drawer.querySelectorAll(`.toptext-${menuId}`).length){
                let ii = 0;
                this.drawer.querySelectorAll(`.toptext-${menuId}`).forEach(toptext => {
                  toptext.classList.add('active')
                  ii++;
                  if(ii >= this.drawer.querySelectorAll(`.toptext-${menuId}`).length){
                    resolve(menuId);
                  }
                })
              }
              else {
                resolve(menuId);
              }
            })
        }
        else {
          resolve(false);
        }
      }) 
    }

    menuDetect().then(res => {
		if(!res){
			this.drawer.querySelectorAll('.sub-main-menu').forEach(menu => {
				menu.classList.remove('active')
				menu.classList.remove('move')
			});
			
			this.drawer.querySelector('.main-menu').classList.add('active');
		}
      
    }).then(() => {
        this.drawer.classList.add('active')
        if(!document.querySelector('.sa-backdrop')){
            const backdrop = document.createElement('div');
            backdrop.className = 'sa-backdrop';
            backdrop.onclick = function (e) {
              console.log('click drop')
              drawer.close();
            }
            document.querySelector('body').append(backdrop);
        }

        document.querySelector('body').classList.add('sa-overlay');
    })
    .then(() => {
      drawer.lazyloadImage(); 
    })

  }

  close() {
	this.drawer.classList.remove('active')
	this.drawer.classList.remove('notPrimary')
	  
    this.drawer.querySelector('.main-menu').classList.remove('active')
    this.drawer.querySelectorAll('.menu-list').forEach(m => m.classList.remove('active'))
    this.drawer.querySelectorAll('.menu-holder').forEach(m => m.classList.remove('active'))
    if(document.querySelector('.sa-backdrop')) document.querySelector('.sa-backdrop').remove();
	  document.querySelector('body').classList.remove('sa-overlay');
	  

  }

  lazyloadImage() {
    //console.log('lazyload')
    const self = this;
    var lazyloadImages = document.querySelectorAll("img.lazyloaded");
      lazyloadImages.forEach(function (img) {
          let src = '';
        let hide = false;
        
          if (img && img.dataset && images_menus[img.dataset.imageId]) {
            if (img.dataset.src && img.dataset.src.includes("http")) {
              src = img.dataset.src;
            } else {
              if (!images_menus[img.dataset.imageId].includes('no-image')) {
                src = images_menus[img.dataset.imageId];
              } else {
                hide = true;
              }
            }
          }

          if (!src && img && img.dataset) {
            src = img.dataset.src;
          }

          if(src && image_dimension){
            src = self.addParameterToURL(src, 'height', image_dimension)
          }
          
          img.classList.remove('lazy');
          img.classList.remove('lazyloaded');
          img.removeAttribute("data-src");
          img.src = src;
          img.style.width = '45px'
          img.style.height = 'auto'
          img.style.opacity = 1
          // Create a new image element
        /*
          var newImg = document.createElement("img");
          newImg.className = "menu-image";
          newImg.src = src;
          
          if(hide) newImg.style.display = 'none'

          // Replace the existing img element with the new image
          img.parentNode.replaceChild(newImg, img);
        */
        
          
        });
  }

  addParameterToURL(url, parameterName, parameterValue) {
      var newParameter = parameterName + '=' + encodeURIComponent(parameterValue);
      var regex = new RegExp('([?&])' + parameterName + '[^&]*');
  
      if (url.match(regex)) {
          return url.replace(regex, '$1' + newParameter);
      } else {
          var separator = (url.indexOf('?') !== -1) ? '&' : '?';
          return url + separator + newParameter;
      }
  }
	
  handleResolutionChange() {
	  this.close()
  }

  connectedCallback() {
	  const self = this; // Store the reference to SaDrawer instance
	  //window.addEventListener("resize", self.handleResolutionChange);

        document.addEventListener("DOMContentLoaded", function() {
            var lazyloadImages = document.querySelectorAll("img.lazyloaded");
            var lazyloadThrottleTimeout;

            function lazyload() {
              //console.log('connectedCallback lazyload ')
                if (lazyloadThrottleTimeout) {
                    clearTimeout(lazyloadThrottleTimeout);
                }
  
                lazyloadThrottleTimeout = setTimeout(function() {
                  lazyloadImages.forEach(function (img) {
                    let src = null;
                    let hide = false;
                    
                    if (img && img.dataset && img.dataset.imageId) {
                      const imageId = img.dataset.imageId;
                      if (images_menus[imageId]) {
                        src = img.dataset.src && img.dataset.src.includes("http")
                          ? img.dataset.src
                          : (images_menus[imageId].includes('no-image') ? null : images_menus[imageId]);
                      } else {
                        hide = true;
                      }
                    }

                      if(src && image_dimension){
                        src = self.addParameterToURL(src, 'height', image_dimension)
                      }

                      var newImg = document.createElement("img");
                      newImg.className = "menu-image lazyloaded";
                      newImg.dataset.src = src;
                      newImg.setAttribute('width', '45px')
                      newImg.setAttribute('height', 'auto')
                      newImg.style.opacity = '0.5'
                      
                      if(hide) newImg.style.display = 'none'
                      img.parentNode.replaceChild(newImg, img);
                      
                    
                    });
                }, 20);
          }

            lazyload();
            
        });
    
      document.addEventListener('MenuReady', function (event) {
        if (event && event.detail && event.detail.myData) {
          const elements = document.querySelectorAll('.nav-icon');
          elements.forEach(function(element) {
            element.addEventListener('click', function(e) {
              e.preventDefault();
              self.open();
            });
          });
        }
        
      });
    }
  
}


customElements.define('sa-drawer', SaDrawer);